module.exports = [
	"cent",
	"copy",
	"divide",
	"gt",
	"lt",
	"not",
	"para",
	"times"
];


//////////////////
// WEBPACK FOOTER
// ./~/stringify-entities/dangerous.json
// module id = 248
// module chunks = 1